import CompLayout from "@/pcomponents/comp/layout/layout";
import Style from "./css/style.module.css";
import { useState, useRef, useEffect, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListAggrid from '@/pcomponents/common/crud/list/aggrid/list';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";
import strFunc from '@/lib/lyg/string';
import { useSelector } from 'react-redux';
import LoadingComponent from "@/pcomponents/common/content/loading";
import SearchArea from "./area/search";
import WriteRoomComponent from "./area/write";

function RoomList() {
  const xColumnArr = getXcolumnJson();
  const writeRoomComponentRef = useRef<any>(null);
  const listAggridRef = useRef<any>();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_name_like: "",
    s_is_use: "1",
    s_addon_desk: "1",
  });
  let user = useSelector((state: any) => state.user);
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [isShowRight, setIsShowRight] = useState(true);
  const [corp_opt_data, set_corp_opt_data] = useState<any>({
    a_corp_seq: "1",
    a_attend_is_target_time: "",
  });
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  useEffect(() => {
    get_corp_opt_by_ajax();
  }, [user]);

  const get_corp_opt_by_ajax = () => {
    if (strFunc.is_empty(user.comp_seq)) {
      return false;
    }
    if (strFunc.is_empty(user.corp_seq)) {
      return false;
    }
    let formJsonData = {
      "s_seq": ["1"],
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/corp/corp_opt/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            let corp_opt_info = response.data["data"]["info_arr"][0];
            set_corp_opt_data({
              ...corp_opt_data,
              ...corp_opt_info
            });
          }
        }
      });
  };

  const go_update_corp_opt = (inData: any) => {
    let opt_obj = {
      corp_opt_data: corp_opt_data,
      ...inData
    };
    let change_corp_opt_data = {
      ...opt_obj["corp_opt_data"],
    };
    if (strFunc.is_empty(change_corp_opt_data["a_corp_seq"])) {
      change_corp_opt_data["a_corp_seq"] = 1;
    }
    let formJsonData = {
      data_arr: [change_corp_opt_data],
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/corp/corp_opt/write', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "저장 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const on_change_corp_opt = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      ...inData
    };
    let change_corp_opt_data = { ...corp_opt_data };
    change_corp_opt_data[opt_obj["name"]] = opt_obj["value"];
    set_corp_opt_data(change_corp_opt_data);
    go_update_corp_opt({ "corp_opt_data": change_corp_opt_data });
  };

  const list = (inOptObj: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    change_list_opt["sc"] = listAggridRef.current.getListSc();
    setListOpt(change_list_opt);
    let form_json_data = change_list_opt;
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/room/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          listAggridRef.current.setInfoArr(response.data["data"]["info_arr"]);
        } else {

        }
      });
  };

  const goDelete = useCallback((e: any) => {
    let selected_row = listAggridRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }

    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let del_form_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/room/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  }, []);

  const goWriteFrame = (isUpdate: boolean) => {
    let selected_row = listAggridRef.current.getSelectedRows();
    let row_data = {
      "a_seq": "",
      "a_name": "",
      "a_size_x": 5,
      "a_size_y": 5,
      "a_location": "",
      "a_memo": "",
    };
    if (isUpdate == false) {
      listAggridRef.current.setSelectFalseAll();
      selected_row = [];
    } else {
      if (selected_row.length == 0) {
        alert("선택이 없습니다.");
        return false;
      } else if (selected_row.length != 1) {
        alert("한개만 선택해 주세요.");
        return false;
      }
      row_data = selected_row[0];
    }
    if (writeRoomComponentRef.current == null) {
      return false;
    }
    writeRoomComponentRef.current.setRowDataChild(row_data, isUpdate);
  };

  const moveOrderNum = (row_data: any, up_down: string) => {
    let row_num = 0;
    let tmp_section_arr: any = listAggridRef.current.getRows();
    let info_arr_len = tmp_section_arr.length;

    for (let i = 0; i < info_arr_len; i++) {
      if (row_data.a_seq == tmp_section_arr[i]["a_seq"]) {
        row_num = i;
      }
    }

    let next_row_num = row_num;
    if (up_down == "up") {
      next_row_num = row_num - 1;
    } else if (up_down == "down") {
      next_row_num = row_num + 1;
    }

    if (next_row_num < 0) {
      return false;
    }
    if (next_row_num >= tmp_section_arr.length) {
      return false;
    }

    let now_row_data = tmp_section_arr[row_num];
    let change_row_data = tmp_section_arr[next_row_num];

    tmp_section_arr[row_num] = change_row_data;
    tmp_section_arr[next_row_num] = now_row_data;
    let up_order_num_arr = [];
    for (let i = 0; i < info_arr_len; i++) {
      up_order_num_arr.push({
        "a_seq": tmp_section_arr[i]["a_seq"],
        "a_order_num": i + 1,
      });
    }
    let up_form_json_data = {
      "is_update": "1",
      "data_arr": up_order_num_arr,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/room/write', up_form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const cellClickedListener = useCallback((params: any) => {
    var key = params.colDef.field;
    goWriteFrame(true);
  }, []);

  const cellRenderer = useCallback((params: any) => {
    var key = params.colDef.field;
    var render_str = params.value;

    if (key == "row_view_xy") {
      render_str = params.data.a_size_x + "," + params.data.a_size_y;
    } else if (key == "row_view_order") {
      render_str = (
        <div>
          <button className="btn-s btn-dark" onClick={() => { moveOrderNum(params.data, "up"); }} >▲</button>
          <button className="btn-s btn-dark ml-1" onClick={() => { moveOrderNum(params.data, "down"); }} >▼</button>
        </div>
      );
    }

    return render_str;
  }, []);

  return (
    <CompLayout>
      <div className={"con_wrap " + Style.room_wrap}>
        <div className={Style.room_left_wrap} style={{ position: "relative" }}>
          <SearchArea
            list={list}
            listOpt={listOpt}
            setListOpt={setListOpt}
            isShowRight={isShowRight}
            setIsShowRight={setIsShowRight}
            goWriteFrame={goWriteFrame}
            goDelete={goDelete}
          ></SearchArea>
          <ListAggrid
            ref={listAggridRef}
            infoArr={infoArr}
            xColumnArr={{ ...xColumnArr }}
            list={list}
            gridOpt={{
              fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
              is_idx_num: false,
              is_add_checkbox: false,
              floatingFilter: false,
              rowMultiSelectWithClick: false,
              onGridReady: () => {
                list({});
              },
              onCellClicked: cellClickedListener,
              cellRenderer: cellRenderer
            }}
          ></ListAggrid>
          <Paging now_page={listOpt.now_page}
            num_per_page={listOpt.num_per_page}
            total_rec={countInfo.tot}
            onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
        </div>
        {isShowRight &&
          <div className={Style.room_center_wrap}>
            <div className="text-right">
              <span>
                자동종료
                <span className="ml-1" style={{ display: "inline-block" ,width:100}}>
                  <SelectBoxBar
                    name="a_attend_is_target_time"
                    value={corp_opt_data.a_attend_is_target_time}
                    valueTextArr={[
                      { value: "1", text: "예" },
                      { value: "", text: "아니오" },
                    ]}
                    on_change={(inData: any) => {
                      on_change_corp_opt({ name: inData.name, value: inData.value });
                    }}
                  ></SelectBoxBar>
                </span>
              </span>
            </div>
            <WriteRoomComponent
              ref={writeRoomComponentRef}
              list={list}
            ></WriteRoomComponent>
          </div>
        }
      </div>
      <LoadingComponent is_display={loading_data.is_display} text={loading_data.text}></LoadingComponent>
    </CompLayout>
  );
}

export default RoomList;